import React from 'react'
import PropTypes from 'prop-types'

const Transactions = (props) => {
  const { transactions } = props
  const sortedTransactions = transactions.sort((a, b) => {
    return a.createdAt > b.createdAt ? 1 : -1
  })

  return (
    <div>
      <br />
      <table className="table table-hover page">
        <thead>
          <tr>
            <th>Date</th>
            <th>Transaction Id</th>
            <th>Order Number</th>
            <th>User Email</th>
            <th>Amount</th>
            <th>Service Fee</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody id="transactions">
          {sortedTransactions.length > 0 ? (
            sortedTransactions.map((t) => (
              <tr key={t.transactionId || t.id}>
                <td> {t.createdAt} </td>
                <td> {t.transactionId} </td>
                <td> {t.orderNumber} </td>
                <td>
                  <a href={'/users/' + t.userId}> {t.userEmail} </a>
                </td>
                <td> ${t.amount} </td>
                <td> ${t.serviceFeeAmount} </td>
                <td> {t.status} </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6">
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '1.2em',
                    color: 'rgba(0,0,0,0.2)',
                    padding: '20px',
                    backgroundColor: 'rgba(0,0,0,0.01)',
                  }}
                >
                  {' '}
                  No transactions yet.{' '}
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  )
}

Transactions.propTypes = {
  transactions: PropTypes.arrayOf(PropTypes.object),
}

Transactions.defaultProps = {
  transactions: [],
}

export default Transactions
